import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { COMPANY } from "@/data/products";

const links = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/products", label: "Products" },
  { to: "/invest", label: "Invest" },
  { to: "/mine-for-sale", label: "Mine For Sale" },
  { to: "/careers", label: "Careers" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 backdrop-blur-xl bg-[var(--eel-bg)]/92 border-b border-[var(--eel-border)]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={COMPANY.logoUrl}
            alt="EELLEVEN MINING"
            className="w-12 h-12 rounded-full object-cover ring-1 ring-[var(--eel-copper)]/40 group-hover:ring-[var(--eel-copper)] transition"
          />
          <div className="hidden sm:flex flex-col leading-none">
            <span className="font-heading font-black tracking-tighter text-base uppercase">
              <span className="text-white">EELLEVEN</span>{" "}
              <span className="copper-text">Mining</span>
            </span>
            <span className="text-[9px] uppercase tracking-[0.32em] text-zinc-500 mt-1.5">
              Strength · Strategy · Sustainable Future
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `px-2.5 py-2 text-[11px] font-semibold tracking-[0.15em] uppercase whitespace-nowrap transition-colors ${
                  isActive
                    ? "text-[var(--eel-copper)]"
                    : "text-zinc-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link
            to="/contact"
            data-testid="nav-cta-inquire"
            className="ml-3 px-5 py-2.5 copper-bg text-black font-semibold text-[11px] tracking-[0.18em] uppercase hover:bg-[var(--eel-copper-hover)] transition-colors"
          >
            Request Quote
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden p-2 text-zinc-300"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden border-t border-zinc-800 bg-zinc-950"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.end}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `px-3 py-3 text-sm uppercase tracking-wide ${
                    isActive
                      ? "text-[var(--eel-copper)]"
                      : "text-zinc-300"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 px-4 py-3 copper-bg text-black font-semibold text-sm uppercase tracking-wider text-center"
            >
              Request Quote
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
